<div class="dialog-info">
  <div class="header">Aktualność danych</div>
  <div id="info-message" tabindex="0">
    @if (isUserDataValid()) {
      <app-info-message
        style="padding-bottom: 5px"
        [labelHTML]="'Prosimy o zweryfikowanie aktualności danych konta.'"
      ></app-info-message>
    } @else {
      <p-message severity="warn" icon="pi pi-info-circle">
        Twoje dane wymagają poprawy.
      </p-message>
    }
  </div>
  <div class="content flex flex-col gap-10">
    <p-card header="Dane osobowe" tabindex="0" class="custom-card">
      <app-preview-beneficiary-details
        [beneficiary]="beneficiary()"
      ></app-preview-beneficiary-details>
    </p-card>
    <p-card header="Dane kontaktowe" tabindex="0" class="custom-card">
      <app-preview-contact-details
        [beneficiary]="beneficiary()"
      ></app-preview-contact-details>
    </p-card>
    <app-preview-beneficiary-address
      [beneficiary]="beneficiary()!"
    ></app-preview-beneficiary-address>
    <p-card
      class="lastCard custom-card"
      header="Numer konta bankowego"
      tabindex="0"
    >
      <app-preview-account-number
        [bankAccount]="beneficiary().kontoBankowe!"
      ></app-preview-account-number>
    </p-card>
  </div>

  <div class="buttons">
    <p-button
      [label]="'Edytuj dane'"
      (click)="dynamicDialogRef.close('edit-data')"
      styleClass="customInfoButton outlined"
      size="small"
    ></p-button>
    @if (isUserDataValid()) {
      <p-button
        [label]="'Potwierdź dane'"
        (click)="verifyData()"
        styleClass="customInfoButton"
        size="small"
      ></p-button>
    }
  </div>
</div>
